import { Component, OnInit, Input, Directive  } from '@angular/core';
import { ContentManagementService } from '../../shared/services/content-management.service';

import { AlertsService } from '../../policy/services/alerts.service';
import { Alerts } from '../../policy/models/index';


@Component({
    selector: 'app-warning-banner',
    templateUrl: './warning-banner.component.html',
    styleUrls: ['./warning-banner.component.scss'],
    imports: []
})
export class WarningBannerComponent implements OnInit{

  @Input() displayBanner: boolean;
  @Input() domain: string;  
  alerts: Alerts[] = [];
  
  constructor(private cmsService: ContentManagementService,
    private alertsService: AlertsService) { }

  ngOnInit() {
    this.loadAlerts();
  }

   /**
   * Gets the alerts
   * @returns {void}
   */
   loadAlerts(): void {
    this.alertsService.getAlerts().subscribe((alerts: Alerts[] = []) => {
      this.alerts = alerts
        .filter(a => a.Application?.toLowerCase().includes('esites'))
        .filter(a => a.Status === 'Active')
        .sort((a, b) =>
          (parseInt(a.DisplayOrder, 10) || 999) - (parseInt(b.DisplayOrder, 10) || 999)
        );
    }, () => { this.alerts = []; });
  } 

}
